import axios from "axios";
import auth from "../utils/auth";
import cfg from "../utils/config";

const getConfig = () => ({
    headers: {
        Authorization: `Bearer ${auth.getToken()}`
    }
});

const getBaseURL = () => {
    const userInfo = auth.getUserInfo();

    return `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns`;
};

const lnsImportDeviceProfile = {
    async getDeviceProfiles() {
        const requestURL = `${getBaseURL()}/device/profile/`;

        const { data } = await axios.get(requestURL, getConfig());

        return data;
    },

    async getVendors() {
        const requestURL = `${getBaseURL()}/vendors/`;

        const { data } = await axios.get(requestURL, getConfig());

        return data;
    },

    async getDevices(vendorId) {
        const requestURL = `${getBaseURL()}/vendors/${vendorId}/devices/`;

        const { data } = await axios.get(requestURL, getConfig());

        return data;
    },

    async getProfiles(vendorId, deviceId) {
        const requestURL = `${getBaseURL()}/vendors/${vendorId}/devices/${deviceId}/`;

        const { data } = await axios.get(requestURL, getConfig());

        return data;
    },

    async getProfileDetail(vendorId, deviceId, profileId) {
        const requestURL = `${getBaseURL()}/vendors/${vendorId}/devices/${deviceId}/profile/${profileId}/`;

        const { data } = await axios.get(requestURL, getConfig());

        return data;
    },

    async importProfile(vendorId, deviceId, profileId, clienteId) {
        const requestURL = `${getBaseURL()}/vendors/${vendorId}/devices/${deviceId}/profile/${profileId}/import/`;
        const body = clienteId !== undefined ? { cliente: clienteId } : {};

        return axios.post(requestURL, body, getConfig());
    }
};

export default lnsImportDeviceProfile;